import { render } from "./BackgroundStars.vue?vue&type=template&id=62105200&scoped=true"
import script from "./BackgroundStars.vue?vue&type=script&lang=js"
export * from "./BackgroundStars.vue?vue&type=script&lang=js"

import "./BackgroundStars.vue?vue&type=style&index=0&id=62105200&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62105200"]])

export default __exports__